import {
    LineChart,
    MessageCircle,
    PackageOpen,
    ShoppingCart,
    User2,
} from "lucide-react";

export const features = [
    {
        name: "profile",
        icon: <User2 className="h-5 w-5" />,
        link: "/dashboard/profile",
    },
    {
        name: "orders",
        icon: <ShoppingCart className="h-5 w-5" />,
        link: "/dashboard/orders",
    },
    {
        name: "analytics",
        icon: <LineChart className="h-5 w-5" />,
        link: "/dashboard/analytics",
    },
    {
        name: "inventory",
        icon: <PackageOpen className="h-5 w-5" />,
        link: "/dashboard/inventory",
    },
    {
        name: "communication",
        icon: <MessageCircle className="h-5 w-5" />,
        link: "/dashboard/communication",
    },
];
